
    <span class="ro-loading " *ngIf="show"></span>
    <span style="vertical-align: middle;" *ngIf="show">{{ message }}</span>
    <span style="vertical-align: middle;" *ngIf="!show">{{ content }}</span>
  